import type { MouseEvent } from 'react';

// Controls inside a clickable row keep their own behaviour.
const INTERACTIVE = 'a, button, input, select, textarea, label, [role="menu"], [role="menuitem"], [data-row-click-ignore]';

// Lets a whole table row or card open its details. Clicks on controls inside it, and
// clicks that end a text selection (copying a phone number), are left alone.
export function openOnRowClick(open: () => void) {
    return (event: MouseEvent<HTMLElement>) => {
        const target = event.target as HTMLElement | null;
        if (target?.closest(INTERACTIVE)) return;
        if (window.getSelection?.()?.toString()) return;
        open();
    };
}
